import React, { useState, useEffect, useRef } from 'react';
import { Form, Formik, useFormikContext } from 'formik';
import dayjs from 'dayjs';
import Calendar from 'react-calendar';
import cc from 'classcat';
import { useClickAway } from 'react-use';
import { observer } from 'mobx-react-lite';
import styles from './searchdepartures.module.sass';
import { Button } from '../../Button';
import { SearchCity } from '../../SearchCity';
import { useDeparturesStore } from '../../../providers/RootStoreProvider';

const DateFormat = 'YYYY-MM-DD';

export const plusUnitToDate = (day = 0) =>
  dayjs().add(day, 'day').format(DateFormat);

const dates = [
  {
    name: 'today',
    title: `Сегодня, ${dayjs().format('D MMMM')}`,
    value: plusUnitToDate(),
  },
  {
    name: 'tomorrow',
    title: 'Завтра',
    value: plusUnitToDate(1),
  },
  {
    name: 'day-after-tomorrow',
    title: 'Послезавтра',
    value: plusUnitToDate(2),
  },
];

// const checkIsCustomDate = d => !dates.some(i => i.value === d);

const UpdateList = () => {
  const { values, submitForm } = useFormikContext();
  const store = useDeparturesStore();
  const filter = (c, s) => store.filterByCityAndShip(c, s);
  useEffect(() => {
    filter(values.selectedCities, values.selectedShips);
  }, [values.selectedCities, values.selectedShips, submitForm]);

  return null;
};

export const SearchDepartures = observer(({ className, ...props }) => {
  const [isOpenCalendar, setIsOpenCalendar] = useState(false);
  const actionsWrapperRef = useRef();
  const store = useDeparturesStore();
  const { cities, ships, timeTable } = store;
  const [activeButton, setActiveButton] = useState('today');

  const fetchData = d => store.fetchByDate(d);

  const filterCities = selectedShips =>
    selectedShips.length === 0
      ? cities
      : timeTable
          .filter(item => selectedShips.includes(item.t_title))
          .map(item => item.route_start)
          .filter((item, index, arr) => arr.indexOf(item) === index);

  const filterShips = selectedCities =>
    selectedCities.length === 0
      ? ships
      : timeTable
          .filter(item => selectedCities.includes(item.route_start))
          .map(item => item.t_title)
          .filter((item, index, arr) => arr.indexOf(item) === index);

  useClickAway(actionsWrapperRef, () => setIsOpenCalendar(false));
  const btn = <span className={cc([styles.arrow])} />;

  return (
    <div
      className={cc([styles.wrapper, { [className]: !!className }])}
      {...props}
    >
      <Formik
        initialValues={{
          selectedCities: [],
          selectedShips: [],
          date: dayjs().format('YYYY-MM-DD'),
          cities,
          ships,
        }}
      >
        {({ values, setFieldValue, resetForm }) => {
          const calendar = (
            <Calendar
              className={cc(['departures-calendar'])}
              prevLabel={btn}
              nextLabel={btn}
              locale={'ru-RU'}
              value={new Date(values.date)}
              onChange={async date => {
                setFieldValue('date', dayjs(date).format(DateFormat));
                setIsOpenCalendar(false);
                await fetchData(dayjs(date).format(DateFormat));
              }}
            />
          );

          return (
            <Form>
              <UpdateList />
              <div className={styles.top}>
                <SearchCity
                  id="selectedCities"
                  label="Город отправления"
                  cities={filterCities(values.selectedShips)}
                  value={values.selectedCities}
                />
                <SearchCity
                  id="selectedShips"
                  label="Название теплохода"
                  cities={filterShips(values.selectedCities)}
                  value={values.selectedShips}
                />
              </div>
              <div ref={actionsWrapperRef}>
                <div className={styles.actions}>
                  {dates.map(({ name, title, value }) => (
                    <Button
                      key={title}
                      size="sm"
                      view="white"
                      onClick={async () => {
                        resetForm();
                        setFieldValue('date', value);
                        setActiveButton(name);
                        setIsOpenCalendar(false);
                        await fetchData(value);
                      }}
                      className={activeButton === name ? styles.active : ''}
                    >
                      {title}
                    </Button>
                  ))}
                  <div className={styles.relative}>
                    <Button
                      className={
                        activeButton === 'custom-date' ? styles.active : ''
                      }
                      view="white"
                      size="sm"
                      onClick={() => {
                        setIsOpenCalendar(!isOpenCalendar);
                        setActiveButton('custom-date');
                      }}
                    >
                      {activeButton === 'custom-date'
                        ? dayjs(values.date, DateFormat).format('D MMMM YYYY')
                        : 'Своя дата'}
                    </Button>
                    {isOpenCalendar && (
                      <div
                        className={cc([
                          styles.calendar,
                          { [styles.active]: isOpenCalendar },
                        ])}
                      >
                        {calendar}
                      </div>
                    )}
                  </div>
                </div>
                {isOpenCalendar && (
                  <div
                    className={cc([
                      styles.calendar,
                      styles.mobile,
                      { [styles.active]: isOpenCalendar },
                    ])}
                  >
                    {calendar}
                  </div>
                )}
              </div>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
});
